"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelOptionsForReactHooks = exports.version = void 0;
exports.version = '2.10.0';
/**
 * channel options for react-hooks
 */
function channelOptionsForReactHooks(options) {
    return Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.params), { agent: `react-hooks/${exports.version}` }), 
        // we explicitly attach channels in React hooks (useChannel, usePresence, usePresenceListener)
        // to avoid situations where implicit attachment could cause errors (when connection state is failed or disconnected)
        attachOnSubscribe: false });
}
exports.channelOptionsForReactHooks = channelOptionsForReactHooks;
//# sourceMappingURL=AblyReactHooks.js.map